
import Vue from 'vue';

import { BLSearchParameters } from '@/types/blacklabtypes';
import { NormalizedAnnotation, NormalizedMetadataField } from '@/types/apptypes';

import {GroupRowData, definitions} from '@/pages/search/results/table/groupTable';
import GroupRow from '@/pages/search/results/table/GroupRow.vue';
import GroupRowDetails from '@/pages/search/results/table/GroupRowDetails.vue';

export {GroupRowData} from '@/pages/search/results/table/groupTable';

export default Vue.extend({
	components: {
		GroupRow, GroupRowDetails
	},
	props: {
		type: String as () => 'hits'|'docs',
		headers: Array as () => Array<{
			label: string,
			key: string,
			title: string,
			sortProp?: string,
			isBar?: boolean
		}>,
		columns: Array as () => Array<keyof GroupRowData|[keyof GroupRowData, keyof GroupRowData]>,
		data: Array as () => GroupRowData[],
		maxima: Object as () => Record<keyof GroupRowData, number>,

		mainAnnotation: Object as () => NormalizedAnnotation,
		/** Required to render group contents if they're hits, optional */
		otherAnnotations: Array as () => NormalizedAnnotation[]|undefined,
		/** Required to render group contnets if they're metadata. optional. */
		metadata: Array as () => NormalizedMetadataField[]|undefined,

		/** Required to render group contents if they're hits. */
		query: Object as () => BLSearchParameters,
		disabled: Boolean,
		html: Boolean,
		dir: String as () => 'ltr'|'rtl',

	},
	data: () => ({
		definitions,
		open: {} as Record<string, boolean>,
	}),
	methods: {
		changeSort(sortProp: string) {
			this.$emit('changeSort', sortProp);
		}
	},
	watch: {
		query() {
			this.open = {};
		}
	}
})
